import { BigNumber } from '../utils/bignumber';
import moment from 'moment';

import { NULL_BYTES32, NULL_ECDSA_SIGNATURE } from '../utils/constants'
import { ECDSASignature } from './ecdsa_signature'

export const APPLICATION_ORDER_DATA_DEFAULTS = {
  id: new BigNumber(0),
  applicationHash: NULL_BYTES32,
  salt: new BigNumber(0),
  responses: [],
  type: 'Term Life',
  desiredCoverage: new BigNumber(0),
  duration: new BigNumber(
    moment()
      .add(20, 'years')
      .unix()
  ),
  expiration: new BigNumber(
    moment()
      .add(30, 'days')
      .unix()
  ),
  isActive: true,
  insuredSignature: NULL_ECDSA_SIGNATURE
}

export interface ApplicationOrderData {
  id?: BigNumber;
  applicationHash?: string;
  salt?: BigNumber;
  responses?: any[];
  type?: string;
  desiredCoverage?: BigNumber;
  duration?: BigNumber;
  expiration?: BigNumber;
  isActive?: boolean;
  insuredSignature?: ECDSASignature;
}
